import React, { useCallback } from 'react';
import { ModuleAccessLevel } from '../../utils/Helper/enums';

interface Props {
  name: string;
  accessType: string;
  disabled: boolean;
  description?: string;
}

const ModuleRow = ({ name, accessType, disabled, description }: Props) => {
  const bgColor = (accessType: string) => {
    if (accessType === ModuleAccessLevel.FULLACCESS) {
      return 'bg-[#28a745]';
    } else if (accessType === ModuleAccessLevel.PARTIALACCESS) {
      return 'bg-[#ffc107]';
    }
    return 'bg-gray';
  };

  return (
    <div
      key={name}
      className="bg-white pt-6 rounded-lg shadow-md hover:shadow-xl transition-all transform hover:scale-105 text-ellipsis flex flex-col justify-between overflow-hidden"
    >
      <div className="p-6 pt-0">
        <h3 className="text-xl text-black font-semibold mb-2">{name}</h3>
        {description && (
          <div className="relative group">
            <p className="text-gray-500 text-sm mb-2 truncate">
              {description}
            </p>
            <div className="absolute z-50 hidden group-hover:block bg-white text-black text-xs border border-black rounded-md px-3 py-2 max-w-[250px] whitespace-normal break-words shadow-lg bottom-full left-0 mb-1">
              {description}
            </div>
          </div>
        )}
        <p className="text-gray-600 text-lg italic">{accessType}</p>
      </div>
      <div className={`h-[10px] w-full ${bgColor(accessType)}`}></div>
    </div>
  );
};

export default ModuleRow;
